import React from 'react'
import Firstsection from './aboutneog/firstSection/Firstsection'
import Secondsection from './aboutneog/secondSection/Secondsection'
import Thirdsection from './aboutneog/thirdSection/Thirdsection'
import Fourthsection from './aboutneog/fourthSection/Fourthsection'

const About = () => {
  return (
    <div>
    <Firstsection/>
    <Secondsection />
    <Thirdsection />
    <Fourthsection />
</div>
  )
}

export default About